import React from 'react'
import { faAngleDown, faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Col, Row } from 'react-bootstrap'
import OrderStatus from './OrderStatus'
import { IOrder } from 'order_components/IOrder'

interface IOrderHeaderProps {
  order: IOrder
  isOpen: boolean
  onToggleOpen: (event: any) => void
}

const OrderHeader: React.FC<IOrderHeaderProps> = ({ order, isOpen, onToggleOpen }) => {
  return (
    <Row>
      <Col xs={{ span: 11, order: 1 }} lg={{ span: 6, order: 1 }}>
        <div className='h3-rem digit-font'>
          <a href='/#' onClick={onToggleOpen} className='accordion-link'>
            Заказ № {order.order_id} от {order.sdate}
          </a>
        </div>
      </Col>
      <Col
        xs={{ span: 4, order: 3 }}
        lg={{ span: 2, order: 2 }}
        className='d-flex h3-rem align-items-center'
      >
        {order.required_payment}&nbsp;₽
      </Col>
      <Col
        xs={{ span: 8, order: 4 }}
        lg={{ span: 3, order: 3 }}
        className='d-flex h3-rem'
      >
        <OrderStatus order={order} />
      </Col>

      <Col
        xs={{ span: 1, order: 2 }}
        lg={{ order: 4 }}
        className='d-flex align-items-center h3-rem'
      >
        <a href='/#' onClick={onToggleOpen} className='accordion-link'>
          {isOpen ? (
            <FontAwesomeIcon icon={faAngleDown} />
          ) : (
            <FontAwesomeIcon icon={faAngleRight} />
          )}
        </a>
      </Col>
    </Row>
  )
}
export default OrderHeader
